export const textUtil = {
  methods: {
    initialCaps: function (str) {
      var words = str.split(/[ ]+/).map((w) => {
        var lc = w.toLowerCase()
        return lc.charAt(0).toUpperCase(0) + lc.slice(1)
      })
      return words.join(' ')
    },
    formatUSPhone: function (str) {
      var chunks = str.match(/(\d\d\d)(\d\d\d)(\d\d\d\d)/)
      if (chunks !== null && chunks.length) {
        return '(' + chunks[1] + ') ' + chunks[2] + '-' + chunks[3]
      } else {
        return str
      }
    },
    formatFriendlyDate: function (str) {
      var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }
      return new Date(str).toLocaleTimeString('en-US', options)
    },
    formatDollars: function (str) {
      return '$' + Number(str).toFixed(2)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/textUtil.js